import type { Immutable } from "immer";
import React from "react";
import { getGlobalSpacingClasses } from "tsi-common-react/src/components/_spacing/globalSpacing";

import type { SpacingSubBlock } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

export const OffersPromoContainer = (
    props: Immutable<{
        title: string | null | undefined;
        spacing: SpacingSubBlock | null | undefined;
        children: React.ReactNode;
    }>,
): React.JSX.Element => {
    return (
        <div
            className={concatClassNames([
                styles.offersPromoContainer,
                "main-container",
                getGlobalSpacingClasses(props.spacing),
            ])}
        >
            <h2 className={styles.offersPromoContainerTitle}>{props.title}</h2>
            {props.children}
        </div>
    );
};

export const OfferPromo = (
    props: Immutable<{ children: React.ReactNode }>,
): React.JSX.Element => {
    return (
        <div className={styles.offerPromo} role="group" aria-label="product">
            {props.children}
        </div>
    );
};

export const OfferPromoImage = (
    props: Immutable<{ src: string; alt: string }>,
): React.JSX.Element => {
    return (
        <img
            className={styles.offerPromoImage}
            src={props.src}
            alt={props.alt}
            loading="lazy"
            decoding="async"
        />
    );
};

export const OfferPromoSubheader = (
    props: Immutable<{ children: React.ReactNode }>,
): React.JSX.Element => {
    return <h3 className={styles.offerPromoSubheader}>{props.children}</h3>;
};
